module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-icon-guest-book-a7ad357118df3ec6e06bb107d74dc568.png";